import { makePostRequest } from "../helpers"

export const activateAdministrator = async (administratorId: string) => {
    const result = await makePostRequest(`api/administrators/${administratorId}/activate`, {});

    return result;
}

export const deactivateAdministrator = async (administratorId: string) => {
    const result = await makePostRequest(`api/administrators/${administratorId}/deactivate`, {});

    return result;
}